import { Fragment, useState } from 'react'
import { useTheme } from '@opallabs/hooks'
import { Button } from '@opallabs/lapidary'
import * as styles from './styles'

export type Emoji = {
  name: string
  emoji: string
  id: string
}

type EmojiPopoverContentProps = {
  emojis: Array<Emoji>
  onSelect: (emoji: Emoji) => void
}

export const EmojiPopoverContent: React.FC<EmojiPopoverContentProps> = ({
  emojis,
  onSelect,
}) => {
  const theme = useTheme()
  const [highlightedEmojiIndex, setHighlightedEmojiIndex] = useState<
    number | null
  >(null)

  return (
    <div css={styles.emojiContent}>
      <div css={styles.header(theme)}>
        {highlightedEmojiIndex !== null ? (
          <Fragment>
            <span css={styles.highlightedEmoji}>
              {emojis[highlightedEmojiIndex].emoji}
            </span>
            <span id="emoji-name">{emojis[highlightedEmojiIndex].name}</span>
          </Fragment>
        ) : (
          <span>Choose an emoji</span>
        )}
      </div>
      <ol css={styles.emojiList}>
        {emojis.map((emoji, i) => (
          <Button
            key={emoji.name}
            aria-labelledby={
              highlightedEmojiIndex === i ? 'emoji-name' : undefined
            }
            onMouseEnter={() => setHighlightedEmojiIndex(i)}
            onMouseLeave={() => setHighlightedEmojiIndex(null)}
            onFocus={() => setHighlightedEmojiIndex(i)}
            onBlur={() => setHighlightedEmojiIndex(null)}
            onClick={() => onSelect(emoji)}
            name={emoji.name}
            buttonText={emoji.emoji}
            styleOverrides={{ button: styles.emojiButtonOverrides }}
            variant="tertiary"
          />
        ))}
      </ol>
    </div>
  )
}
